module.exports = __webpack_public_path__ + "static/img/荣誉_10@2x.bb0d70f4.png";